import { render, staticRenderFns } from "./formImport.vue?vue&type=template&id=48ca8aad"
import script from "./formImport.vue?vue&type=script&lang=js"
export * from "./formImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports